import {AnyLinkType} from 'shared/pretty-easy-navigation/models';

export const TrainerMenu: AnyLinkType[] = [
    {
        type: 'linkGroup',
        links: [
            {
                type: 'link',
                label: 'navigation.contests',
                link: '/contests',
                icon: 'navigation-link__home',
            },
            {
                type: 'link',
                label: 'navigation.dashboard',
                link: '/home',
                icon: 'navigation-link__home',
            },
            {
                type: 'accordionLinkGroup',
                label: 'navigation.group_management',
                icon: 'navigation-group__group-management',
                links: [
                    {
                        type: 'link',
                        label: 'navigation.groups',
                        link: '/groups/list/groups',
                        icon: 'navigation-link__list-item',
                    },
                    {
                        type: 'link',
                        label: 'navigation.workgroups',
                        link: '/groups/list/workgroups',
                        icon: 'navigation-link__list-item',
                    },
                    {
                        type: 'link',
                        label: 'navigation.learners',
                        link: '/groups/list/learners',
                        icon: 'navigation-link__list-item',
                    },
                ],
            },
            {
                type: 'accordionLinkGroup',
                label: 'navigation.lessons',
                icon: 'navigation-group__lessons',
                links: [
                    {
                        type: 'link',
                        label: 'navigation.lessons',
                        link: '/lessons/list/models',
                        icon: 'navigation-link__list-item',
                    },
                    {
                        type: 'link',
                        label: 'navigation.custom_lessons',
                        link: '/lessons/list/user-lessons',
                        icon: 'navigation-link__list-item',
                    },
                ],
            },
            {
                type: 'link',
                label: 'navigation.recommendations',
                link: '/page/recommendations',
                icon: 'navigation-link__recommendations',
            },
            {
                type: 'link',
                label: 'navigation.assignments',
                link: '/page/assignments',
                icon: 'navigation-link__assignments',
            },
            {
                type: 'link',
                label: 'navigation.monitoring',
                link: '/page/followed',
                icon: 'navigation-link__monitoring',
            },
            {
                type: 'link',
                label: 'navigation.progress',
                link: '/page/results',
                icon: 'navigation-link__progress',
            },
        ],
    },
    {
        type: 'linkGroup',
        links: [
            {
                type: 'link',
                label: 'navigation.legal_notice',
                link: '/informations-legales',
                icon: 'navigation-link__legal-notice',
            },
            {
                type: 'link',
                label: 'navigation.contact',
                link: '/feedback',
                icon: 'navigation-link__contact',
            },
            {
                type: 'link',
                label: 'navigation.site_map',
                link: '/page/site-map-trainer',
                icon: 'navigation-link__sitemap',
            },
        ],
    },
];
